export default __webpack_public_path__ + "static/media/scene4.43533558.webp";